import { useEffect } from 'react'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import {
  BROADCAST_LIST,
  GET_TODAY_BROADCAST_LIST,
  IS_PREV_BROADCAST_DATA_EXIST,
  MORE_BROADCAST_LIST_INDEX,
  PREV_BROADCAST_LIST_INDEX,
  currentDate,
} from 'core/store/broadcastTable'

/**
 * 오늘 일자의 방송 목록 fetch hook
 */
export default function useTodayBroadcastList() {
  const [broadcastItem, setBroadcastItem] = useRecoilState(BROADCAST_LIST(currentDate))
  const data = useRecoilValue(GET_TODAY_BROADCAST_LIST)
  const setPrevListIndex = useSetRecoilState(PREV_BROADCAST_LIST_INDEX)
  const setMoreListIndex = useSetRecoilState(MORE_BROADCAST_LIST_INDEX)
  const setIsPrevDataExist = useSetRecoilState(IS_PREV_BROADCAST_DATA_EXIST)

  useEffect(() => {
    if (!data || !data.items) return

    setBroadcastItem(data.items)
    /**
     * prevListIndex를 prev 배열의 length로 초기화
     */
    setPrevListIndex(data.items.past.length)
    /**
     * moreListIndex를 fromNow 배열의 length로 초기화
     */
    setMoreListIndex(data.items.fromNow.length)
    /**
     * past 배열 즉, "지난 라이브"가 존재하면 true
     */
    setIsPrevDataExist(data.items.past.length > 0)
  }, [data, setBroadcastItem, setIsPrevDataExist, setMoreListIndex, setPrevListIndex])

  return broadcastItem
}
